import { LDadd, LDdelete, LDinsertResource, LDdeleteResource, LDreplaceResource, LDupdate, LDreplace, LDupdateList, LDnoop, Literal, URI } from './ld-patch-model';

function TransformProcessor(utils) {

	let messages = [];

	function TransformationException(message) {
		this.message = message;
		this.name = "TransformationException";
	}

	this.applyTransform = function (clientObject, serverObject) {

		// Note that the code below is generic and does not assume that the client object and server object are actually referencing
		// the same resource. But for our purposes because a channel is a resource and we keep a bridge per channel it will actually
		// all be the case that they ARE the same!

		messages = [];
		let action;

		if (clientObject.constructor === LDdelete) {
			action = applyClientDeleteTransform(clientObject, serverObject);
		} else if (clientObject.constructor === LDadd) {
			action = applyClientAddTransform(clientObject, serverObject);
		} else if (clientObject.constructor === LDupdate) {
			action = applyClientUpdateTransform(clientObject, serverObject);
		} else if (clientObject.constructor === LDreplace) {
			action = applyClientReplaceTransform(clientObject, serverObject);
		} else if (clientObject.constructor === LDupdateList) {
			action = applyClientUpdateListTransform(clientObject, serverObject);
		} else if (clientObject.constructor === LDdeleteResource) {
			action = applyClientDeleteResourceTransform(clientObject, serverObject);
		} else if (clientObject.constructor === LDinsertResource) {
			action = applyClientInsertResourceTransform(clientObject, serverObject);
		} else {
			throw new TransformationException("Transforming unrecognised object: " + clientObject.constructor);
		}

		return {
			action: action,
			messages: messages
		};
	};

	function applyClientInsertResourceTransform(clientObject, serverObject) {

		const clientIRI = clientObject.getIRI().getText();

		if (serverObject.constructor === LDdeleteResource) {
			// For this to happen another user would have had to inserted then deleted the same resource in the time 
			// this user has inserted the same resource!
			return serverObject;
		}
		else if (serverObject.constructor === LDinsertResource) {
			const serverIRI = serverObject.getIRI().getText();
			if (clientIRI !== serverIRI) return serverObject;
			// Operation from server implies resource exists already so replace local version
			// There is an anticipation that the resources are of the same type - we should ultimately check that
			let ldrr = new LDreplaceResource();
			ldrr.setIRI(new URI(clientIRI));
			ldrr.setReplacementIRI(new URI(serverIRI));
			ldrr.setData(serverObject.getData());
			ldrr.setGraph(clientObject.getGraph());
			messages.push("A conflict has occurred in that you tried to create a resource with the same IRI as another user."
				+ " As the other resource was created first your edit will be removed and replaced with that of the other user.");
			return ldrr;
		}
		else {
			const serverSubjectURI = serverObject.getSubject().getText();
			if (clientIRI !== serverSubjectURI) return serverObject;
			// If we get here it implies that the client insert operation has been sent and the client has joined the channel
			// of an already existing resource and has now received an update on that channel (that is the insert has been missed)
			// This update will be for the existing inserted resource from the server.
			// So we create an empty replacement object - which will essentially wipe out the local version.
			let ldrr = new LDreplaceResource();
			ldrr.setIRI(new URI(clientIRI));
			ldrr.setEmptyReplacement();
			ldrr.setGraph(clientObject.getGraph());
			messages.push("A conflict has occurred in that you tried to create a resource that another user has already created and edited."
				+ " As the other resource was created first your edit will be removed.");
			return ldrr;
		}
	}

	function applyClientDeleteResourceTransform(clientObject, serverObject) {

		if (serverObject.constructor === LDdelete) {
			return applyClientDeleteResourceServerDeleteTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDadd) {
			return applyClientDeleteResourceServerAddTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDupdate) {
			return applyClientDeleteResourceServerUpdateTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDreplace) {
			return applyClientDeleteResourceServerReplaceTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDupdateList) {
			return applyClientDeleteResourceServerUpdateListTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDdeleteResource) {
			return applyClientDeleteResourceServerDeleteResourceTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDinsertResource) {
			return applyClientDeleteResourceServerInsertResourceTransform(clientObject, serverObject);
		} else {
			throw new TransformationException("Transforming unrecognised object: " + serverObject.constructor);
		}
	}

	function applyClientDeleteResourceServerDeleteTransform(clientObject, serverObject) {

		const clientIRI = clientObject.getIRI().getText();
		const serverSubjectURI = serverObject.getSubject().getText();

		// Client as already deleted so ignore any operations against same resource
		if (serverSubjectURI === clientIRI) return new LDnoop();

		return serverObject;
	}

	function applyClientDeleteResourceServerAddTransform(clientObject, serverObject) {

		const clientIRI = clientObject.getIRI().getText();
		const serverSubjectURI = serverObject.getSubject().getText();

		// Client as already deleted so ignore any operations against same resource
		if (serverSubjectURI === clientIRI) return new LDnoop();

		return serverObject;
	}

	function applyClientDeleteResourceServerUpdateTransform(clientObject, serverObject) {

		const clientIRI = clientObject.getIRI().getText();
		const serverSubjectURI = serverObject.getSubject().getText();

		// Client as already deleted so ignore any operations against same resource
		if (serverSubjectURI === clientIRI) return new LDnoop();

		return serverObject;
	}

	function applyClientDeleteResourceServerReplaceTransform(clientObject, serverObject) {

		const clientIRI = clientObject.getIRI().getText();
		const serverSubjectURI = serverObject.getSubject().getText();

		// Client as already deleted so ignore any operations against same resource
		if (serverSubjectURI === clientIRI) return new LDnoop();

		return serverObject;
	}

	function applyClientDeleteResourceServerUpdateListTransform(clientObject, serverObject) {

		const clientIRI = clientObject.getIRI().getText();
		const serverSubjectURI = serverObject.getSubject().getText();

		// Client as already deleted so ignore any operations against same resource
		if (serverSubjectURI === clientIRI) return new LDnoop();

		return serverObject;
	}

	function applyClientDeleteResourceServerDeleteResourceTransform(clientObject, serverObject) {

		const clientIRI = clientObject.getIRI().getText();
		const serverIRI = serverObject.getIRI().getText();

		if (clientIRI === serverIRI) return new LDnoop();

		return serverObject;
	}

	function applyClientDeleteResourceServerInsertResourceTransform(clientObject, serverObject) {
		return serverObject;
	}

	function applyClientDeleteTransform(clientObject, serverObject) {

		if (serverObject.constructor === LDdelete) {
			return applyClientDeleteServerDeleteTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDadd) {
			// This will cover scenarios 5 and 6
			return serverObject;
		} else if (serverObject.constructor === LDupdate) {
			return applyClientDeleteServerUpdateTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDreplace) {
			return applyClientDeleteServerReplaceTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDupdateList) {
			return applyClientDeleteServerUpdateListTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDdeleteResource) {
			return applyClientDeleteServerDeleteResourceTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDinsertResource) {
			return applyClientDeleteServerInsertResourceTransform(clientObject, serverObject);
		} else {
			throw new TransformationException("Transforming unrecognised object: " + serverObject.constructor);
		}
	}

	function applyClientDeleteServerDeleteTransform(clientObject, serverObject) {
		// This will cover scenarios 1 and 2

		const clientSubjectURI = clientObject.getSubject().getText();
		const clientPredicateURI = clientObject.getPredicate().getText();
		const clientObjectObject = clientObject.getObject().getValue();

		const serverSubjectURI = serverObject.getSubject().getText();
		const serverPredicateURI = serverObject.getPredicate().getText();
		const serverObjectObject = serverObject.getObject().getValue();

		if (clientSubjectURI !== serverSubjectURI || clientPredicateURI !== serverPredicateURI || clientObjectObject !== serverObjectObject) {
			// SCENARIO 2
			return serverObject;
		}

		// SCENARIO 1
		return new LDnoop();
	}

	function applyClientDeleteServerDeleteResourceTransform(clientObject, serverObject) {
		return serverObject;
	}

	function applyClientDeleteServerInsertResourceTransform(clientObject, serverObject) {

		const clientSubjectURI = clientObject.getSubject().getText();
		const serverIRI = serverObject.getIRI().getText();

		if (clientSubjectURI === serverIRI) {
			// Operation from server implies resource exists already so replace locally
			let ldrr = new LDreplaceResource();
			ldrr.setIRI(new URI(clientSubjectURI));
			ldrr.setReplacementIRI(new URI(serverIRI));
			ldrr.setData(serverObject.getData());
			ldrr.setGraph(clientObject.getGraph());
			return ldrr;
		}

		return serverObject;
	}

	function applyClientDeleteServerUpdateTransform(clientObject, serverObject) {
		// This will cover scenarios 24, 25 and 26

		const clientSubjectURI = clientObject.getSubject().getText();
		const clientPredicateURI = clientObject.getPredicate().getText();
		const clientObjectObject = clientObject.getObject().getValue();

		const serverSubjectURI = serverObject.getSubject().getText();
		const serverPredicateURI = serverObject.getPredicate().getText();
		const serverObjectReplacementObject = serverObject.getObjectReplacement().getValue();

		if (clientSubjectURI !== serverSubjectURI || clientPredicateURI !== serverPredicateURI) {
			// SCENARIO 25
			return serverObject;
		}
		// Scenario 26: deleted triple on client matches updated server triple
		if (clientObjectObject === serverObjectReplacementObject) {
			// SCENARIO 26
			return serverObject;
		}

		// SCENARIO 24
		let lda = new LDadd();
		lda.setSubject(serverObject.getSubject());
		lda.setPredicate(serverObject.getPredicate());
		lda.setObject(serverObject.getObjectReplacement());
		lda.setGraph(clientObject.getGraph());
		messages.push("A conflict has occurred in that you tried to delete a field another user has just updated. The update has been given priority.");
		return lda;
	}

	function applyClientDeleteServerReplaceTransform(clientObject, serverObject) {
		// Scenarios 51, 51a and 51b

		const clientSubjectURI = clientObject.getSubject().getText();
		const clientPredicateURI = clientObject.getPredicate().getText();
		const clientObjectObject = clientObject.getObject().getValue();

		const serverSubjectURI = serverObject.getSubject().getText();
		const serverPredicateURI = serverObject.getPredicate().getText();
		const serverPredicateReplacementURI = serverObject.getPredicateReplacement().getText();
		const serverObjectObject = serverObject.getObject().getValue();
		const serverObjectReplacementObject = serverObject.getObjectReplacement().getValue();

		if (clientSubjectURI === serverSubjectURI && clientPredicateURI === serverPredicateURI && clientObjectObject === serverObjectObject) {
			// SCENARIO 51
			let lda = new LDadd();
			lda.setSubject(serverObject.getSubject());
			lda.setPredicate(serverObject.getPredicateReplacement());
			lda.setObject(serverObject.getObjectReplacement());
			lda.setGraph(clientObject.getGraph());
			return lda;
		}

		if (clientPredicateURI === serverPredicateReplacementURI && clientObjectObject === serverObjectReplacementObject) {
			// SCENARIO 51b
			let ldd = new LDdelete();
			ldd.setSubject(serverObject.getSubject());
			ldd.setPredicate(serverObject.getPredicate());
			ldd.setObject(serverObject.getObject());
			ldd.setGraph(clientObject.getGraph());
			return ldd;
		}

		// SCENARIO 51a
		return serverObject;
	}

	function applyClientAddTransform(clientObject, serverObject) {

		if (serverObject.constructor === LDdelete) {
			// Scenarios 7 and 8
			return serverObject;
		} else if (serverObject.constructor === LDadd) {
			return applyClientAddServerAddTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDupdate) {
			// This will cover scenarios 32, 33 and 34
			// And also covers functional property scenarios
			return serverObject;
		} else if (serverObject.constructor === LDreplace) {
			return applyClientAddServerReplaceTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDupdateList) {
			// Scenarios 10 and 14
			return serverObject;
		} else if (serverObject.constructor === LDdeleteResource) {
			return serverObject;
		} else if (serverObject.constructor === LDinsertResource) {
			return applyClientAddServerInsertResourceTransform(clientObject, serverObject);
		} else {
			throw new TransformationException("Transforming unrecognised object: " + serverObject.constructor);
		}
	}

	function applyClientAddServerAddTransform(clientObject, serverObject) {
		// This will cover scenarios 3 and 4

		const clientSubjectURI = clientObject.getSubject().getText();
		const clientPredicateURI = clientObject.getPredicate().getText();
		const clientObjectObject = clientObject.getObject().getValue();
		const clientObjectGraph = clientObject.getGraph().getText();
		const clientPredicateGraph = clientObject.getPredicateGraph() ? clientObject.getPredicateGraph().getText() : null;

		const serverSubjectURI = serverObject.getSubject().getText();
		const serverPredicateURI = serverObject.getPredicate().getText();
		const serverObjectObject = serverObject.getObject().getValue();
		const serverPredicateGraph = serverObject.getPredicateGraph() ? serverObject.getPredicateGraph().getText() : null;

		if (clientSubjectURI !== serverSubjectURI) {
			// SCENARIO 4
			return serverObject;
		}

		const uniqueClient = utils.isUniqueLang(clientSubjectURI, clientObjectGraph, clientPredicateURI);
		const uniqueServer = utils.isUniqueLang(serverSubjectURI, clientObjectGraph, serverPredicateURI);

		if (clientPredicateURI !== serverPredicateURI) {
			// Is it possible that one on the predicates is entailable?
			//const isClientEntailable = utils.isEntailedPredicate(clientPredicateURI);
			//const isServerEntailable = utils.isEntailedPredicate(serverPredicateURI);
			const isClientEntailablePredicate = utils.isEntailedPredicatePair(clientPredicateURI, serverPredicateURI);
			const isServerEntailablePredicate = utils.isEntailedPredicatePair(serverPredicateURI, clientPredicateURI);
			// If it is then the entailed value might also cause a constraint violation on uniqueness so we need to do the check
			if (isClientEntailablePredicate) {
				const serverState = utils.computeResourceState(isClientEntailablePredicate, serverObject.getObject().getText(), clientObjectGraph);
				// Assuming language container for now
				// Does client value match a value in the server state
				const doesValueExist = serverState && serverState.find(item => {
					// If language values only permit one per language any language match is a conflict
					if (uniqueClient && item.lang === clientObject.getObject().getLanguage()) return true;
					return item.resource === clientObject.getObject().getText() && item.lang === clientObject.getObject().getLanguage();
				});
				if (doesValueExist) {
					// Server entails value for the client
					let ldr = new LDreplace();
					ldr.setSubject(clientObject.getSubject());
					ldr.setPredicate(clientObject.getPredicate());
					ldr.setObject(clientObject.getObject());
					ldr.setPredicateReplacement(serverObject.getPredicate());
					ldr.setObjectReplacement(serverObject.getObject());
					ldr.setGraph(clientObject.getGraph());
					messages.push("A conflict has occurred in that only one value is allowed per language and"
						+ " two users have tried to add the same language at the same time in different ways."
						+ " Your edit has been updated with the other user's edit as that entails your edit.");
					// SCENARIO 4c
					return ldr;
				}
			}
			else if (isServerEntailablePredicate) {
				const clientState = utils.computeResourceState(isServerEntailablePredicate, clientObject.getObject().getText(), clientObjectGraph);
				// Assuming language container for now
				// Does client state match server value
				const doesValueExist = clientState && clientState.find(item => {
					// If language values only permit one per language any language match is a conflict
					if (uniqueServer && item.lang === serverObject.getObject().getLanguage()) return true;
					return item.resource === serverObject.getObject().getText() && item.lang === serverObject.getObject().getLanguage();
				});
				if (doesValueExist) {
					// Our local operation entails a value for the server operation.
					// Locally we do nothing
					// SCENARIO 4b
					return new LDnoop();
				}
			}
			// SCENARIO 4
			return serverObject;
		}

		if (clientObjectObject !== serverObjectObject) {
			// If there is a unique language constraint on the predicate it will potentially be scenario 4a
			if (uniqueClient) {
				const clientObjectLang = clientObject.getObject().getLanguage();
				const serverObjectLang = serverObject.getObject().getLanguage();
				if (clientObjectLang && clientObjectLang === serverObjectLang) {
					// SCENARIO 4a
					const ldu = new LDupdate();
					ldu.setSubject(clientObject.getSubject());
					ldu.setPredicate(clientObject.getPredicate());
					ldu.setObject(clientObject.getObject());
					ldu.setObjectReplacement(serverObject.getObject());
					ldu.setGraph(clientObject.getGraph());
					messages.push("A conflict has occurred in that only one value is allowed per language and two users have tried to add the same language at the same time with different values."
						+ " Your edit has been updated with the other user's edit as that happened first.");
					return ldu;
				}
			}

			// Is this a functional property? (Predicates are the same at this point)
			const isFunctional = utils.isFunctional(clientSubjectURI, clientObjectGraph, clientPredicateURI, clientPredicateGraph, serverPredicateGraph);
			if (isFunctional) {
				// Scenario 4aa
				const ldu = new LDupdate();
				ldu.setSubject(clientObject.getSubject());
				ldu.setPredicate(clientObject.getPredicate());
				ldu.setObject(clientObject.getObject());
				// In this instance we might need to replace datatype and language so we recreate the object object
				if (serverObject.getObject() instanceof Literal) {
					const serverObjectLang = serverObject.getObject().getLanguage();
					const serverObjectDatatype = serverObject.getObject().getDatatype();
					ldu.setObjectReplacement(new Literal(serverObject.getObject().getText(), serverObjectLang, serverObjectDatatype));
				}
				else {
					ldu.setObjectReplacement(serverObject.getObject());
				}
				ldu.setGraph(clientObject.getGraph());
				messages.push("A conflict has occurred in that only one value is allowed and two users have tried to add different values."
					+ " You entered '" + clientObject.getObject().getText() + "' and the other user entered '" + serverObject.getObject().getText() + "'. "
					+ " Your edit has been updated with the other user's edit as that happened first.");
				return ldu;
			}

			// Otherwise it is still scenario 4
			// SCENARIO 4
			return serverObject;
		}

		// SCENARIO 3
		return new LDnoop();
	}

	function applyClientAddServerReplaceTransform(clientObject, serverObject) {
		// Scenario 49, 49a and 49b

		const clientSubjectURI = clientObject.getSubject().getText();
		const clientPredicateURI = clientObject.getPredicate().getText();
		const clientObjectObject = clientObject.getObject().getValue();

		const serverSubjectURI = serverObject.getSubject().getText();
		const serverPredicateURI = serverObject.getPredicate().getText();
		const serverObjectObject = serverObject.getObject().getValue();
		const serverPredicateReplacementURI = serverObject.getPredicateReplacement().getText();
		const serverObjectReplacementObject = serverObject.getObjectReplacement().getValue();

		if (clientSubjectURI === serverSubjectURI && clientPredicateURI === serverPredicateReplacementURI
			&& clientObjectObject === serverObjectReplacementObject) {
			// SCENARIO 49b
			let ldd = new LDdelete();
			ldd.setSubject(serverObject.getSubject());
			ldd.setPredicate(serverObject.getPredicate());
			ldd.setObject(serverObject.getObject());
			ldd.setGraph(clientObject.getGraph());
			return ldd;
		}

		if (clientSubjectURI === serverSubjectURI && clientPredicateURI === serverPredicateURI && clientObjectObject === serverObjectObject) {
			// SCENARIO 49
			return serverObject;
		}

		if (clientSubjectURI !== serverSubjectURI) {
			// SCENARIO 49a
			return serverObject;
		}

	}

	function applyClientDeleteServerUpdateListTransform(clientObject, serverObject) {
		// This will cover scenarios 9 and 13

		// This doesn't look right? What if delete is deleting list property?
		return serverObject;
	}

	function applyClientAddServerInsertResourceTransform(clientObject, serverObject) {

		const clientSubjectURI = clientObject.getSubject().getText();
		const serverIRI = serverObject.getIRI().getText();

		if (clientSubjectURI === serverIRI) {
			// Operation from server implies resource exists already so replace locally
			let ldrr = new LDreplaceResource();
			ldrr.setIRI(new URI(clientSubjectURI));
			ldrr.setReplacementIRI(new URI(serverIRI));
			ldrr.setData(serverObject.getData());
			ldrr.setGraph(clientObject.getGraph());
			return ldrr;
		}

		return serverObject;
	}

	// ===================== UPDATE PROCESSING ======================

	function applyClientUpdateTransform(clientObject, serverObject) {

		if (serverObject.constructor === LDdelete) {
			return applyClientUpdateServerDeleteTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDadd) {
			return applyClientUpdateServerAddTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDreplace) {
			return applyClientUpdateServerReplaceTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDupdate) {
			return applyClientUpdateServerUpdateTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDupdateList) {
			return applyClientUpdateServerUpdateListTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDdeleteResource) {
			return applyClientUpdateServerDeleteResourceTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDinsertResource) {
			return applyClientUpdateServerInsertResourceTransform(clientObject, serverObject);
		} else {
			throw new TransformationException("Transforming unrecognised object: " + serverObject.constructor);
		}
	}

	function applyClientUpdateServerDeleteTransform(clientObject, serverObject) {
		// This will cover scenarios 28, 29 and 30

		const clientSubjectURI = clientObject.getSubject().getText();
		const clientPredicateURI = clientObject.getPredicate().getText();
		const clientObjectReplacementObject = clientObject.getObjectReplacement().getValue();

		const serverSubjectURI = serverObject.getSubject().getText();
		const serverPredicateURI = serverObject.getPredicate().getText();
		const serverObjectObject = serverObject.getObject().getValue();

		if (clientSubjectURI !== serverSubjectURI || clientPredicateURI !== serverPredicateURI) {
			// SCENARIO 29
			return serverObject;
		}
		if (clientObjectReplacementObject === serverObjectObject) {
			// SCENARIO 30
			return new LDnoop();
		}

		// SCENARIO 28
		return new LDnoop();
	}

	function applyClientUpdateServerDeleteResourceTransform(clientObject, serverObject) {
		return serverObject;
	}

	function applyClientUpdateServerInsertResourceTransform(clientObject, serverObject) {

		const clientSubjectURI = clientObject.getSubject().getText();
		const serverIRI = serverObject.getIRI().getText();

		if (clientSubjectURI === serverIRI) {
			// Operation from server implies resource exists already so replace locally
			let ldrr = new LDreplaceResource();
			ldrr.setIRI(new URI(clientSubjectURI));
			ldrr.setReplacementIRI(new URI(serverIRI));
			ldrr.setData(serverObject.getData());
			ldrr.setGraph(clientObject.getGraph());
			return ldrr;
		}

		return serverObject;
	}

	function applyClientUpdateServerAddTransform(clientObject, serverObject) {
		// This will cover scenarios 36, 37 and 38
		// This will also cover functional property updates where we assume that the fact an update is happening overrides the add

		const clientSubjectURI = clientObject.getSubject().getText();
		const clientPredicateURI = clientObject.getPredicate().getText();
		const clientObjectReplacementObject = clientObject.getObjectReplacement().getValue();

		const serverSubjectURI = serverObject.getSubject().getText();
		const serverPredicateURI = serverObject.getPredicate().getText();
		const serverObjectObject = serverObject.getObject().getValue();

		if (clientSubjectURI !== serverSubjectURI || clientPredicateURI !== serverPredicateURI) {
			// SCENARIO 37
			return serverObject;
		}
		if (clientObjectReplacementObject !== serverObjectObject) {
			// SCENARIO 38
			return new LDnoop();
		}

		// SCENARIO 36
		return new LDnoop();
	}

	function applyClientUpdateServerUpdateTransform(clientObject, serverObject) {
		// This will cover scenarios 45, 46, 47 and 47a

		const co = clientObject;
		const so = serverObject;

		const clientSubjectURI = co.getSubject().getText();
		const clientPredicateURI = co.getPredicate().getText();
		const clientObjectObject = co.getObject().getValue();
		const clientObjectReplacementObject = co.getObjectReplacement().getValue();
		const clientObjectGraph = clientObject.getGraph().getText();
		const clientPredicateGraph = clientObject.getPredicateGraph() ? clientObject.getPredicateGraph().getText() : null;

		const serverSubjectURI = so.getSubject().getText();
		const serverPredicateURI = so.getPredicate().getText();
		const serverObjectObject = so.getObject().getValue();
		const serverObjectReplacementObject = so.getObjectReplacement().getValue();
		const serverPredicateGraph = serverObject.getPredicateGraph() ? serverObject.getPredicateGraph().getText() : null;

		if (clientSubjectURI !== serverSubjectURI || clientPredicateURI !== serverPredicateURI) {
			// SCENARIO 47
			return serverObject;
		}

		if (clientSubjectURI === serverSubjectURI && clientPredicateURI === serverPredicateURI) {
			const isFunctional = utils.isFunctional(clientSubjectURI, clientObjectGraph, clientPredicateURI, clientPredicateGraph, serverPredicateGraph);
			// SCENARIO 46a
			if (isFunctional) {
				let ldu = new LDupdate();
				ldu.setSubject(co.getSubject());
				ldu.setPredicate(co.getPredicate());
				ldu.setObject(co.getObjectReplacement());
				// In this instance we might need to replace datatype and language so we recreate the object object
				// We don't expect datatype or literal to change on an update really though
				if (serverObject.getObject() instanceof Literal) {
					const serverObjectLang = serverObject.getObjectReplacement().getLanguage();
					const serverObjectDatatype = serverObject.getObjectReplacement().getDatatype();
					ldu.setObjectReplacement(new Literal(serverObject.getObjectReplacement().getText(), serverObjectLang, serverObjectDatatype));
				}
				else {
					ldu.setObjectReplacement(serverObject.getObjectReplacement());
				}
				ldu.setGraph(clientObject.getGraph());
				messages.push("A conflict has occurred in that two users updated the same field at almost the same moment and only one value is allowed."
					+ " You entered '" + co.getObjectReplacement().getText() + "' and the other user entered '" + so.getObjectReplacement().getText() + "'. "
					+ " Your edit has been updated with the other user's edit as that happened first.");
				return ldu;
			}
		}

		if (clientObjectObject !== serverObjectObject) {
			// Different values being updated
			if (clientObjectReplacementObject === serverObjectReplacementObject) {
				// Different values being updated to the same value
				// SCENARIO 47a
				let ldd = new LDdelete();
				ldd.setSubject(serverObject.getSubject());
				ldd.setPredicate(serverObject.getPredicate());
				ldd.setObject(serverObject.getObject());
				ldd.setGraph(clientObject.getGraph());
				return ldd;
			}
			// SCENARIO 47b
			return serverObject;
		}

		if (clientObjectReplacementObject !== serverObjectReplacementObject) {
			// Same value being updated to different values
			// SCENARIO 46
			let ldu = new LDupdate();
			ldu.setSubject(co.getSubject());
			ldu.setPredicate(co.getPredicate());
			ldu.setObject(co.getObjectReplacement());
			ldu.setObjectReplacement(so.getObjectReplacement());
			ldu.setGraph(clientObject.getGraph());
			messages.push("A conflict has occurred in that two users updated the same field at almost the same moment."
				+ " You entered '" + co.getObjectReplacement().getText() + "' and the other user entered '" + so.getObjectReplacement().getText() + "'. "
				+ " Your edit has been updated with the other user's edit as that happened first.");
			return ldu;
		}

		// SCENARIO 45
		return new LDnoop();
	}

	function applyClientUpdateServerReplaceTransform(clientObject, serverObject) {
		// Scenario 52, 52a, 52b, 52c and 52d

		const clientSubjectURI = clientObject.getSubject().getText();
		const clientPredicateURI = clientObject.getPredicate().getText();
		const clientObjectObject = clientObject.getObject().getValue();
		const clientObjectReplacementObject = clientObject.getObjectReplacement().getValue();

		const serverSubjectURI = serverObject.getSubject().getText();
		const serverPredicateURI = serverObject.getPredicate().getText();
		const serverObjectObject = serverObject.getObject().getValue();
		const serverPredicateReplacementURI = serverObject.getPredicateReplacement().getText();
		const serverObjectReplacementObject = serverObject.getObjectReplacement().getValue();

		if (clientSubjectURI === serverSubjectURI && clientPredicateURI === serverPredicateURI && clientObjectObject === serverObjectObject) {
			// SCENARIO 52
			let ldr = new LDreplace();
			ldr.setSubject(serverObject.getSubject());
			ldr.setPredicate(serverObject.getPredicate());
			ldr.setObject(clientObject.getObjectReplacement());
			ldr.setPredicateReplacement(serverObject.getPredicateReplacement());
			ldr.setObjectReplacement(serverObject.getObjectReplacement());
			ldr.setGraph(clientObject.getGraph());
			return ldr;
		}

		if (clientSubjectURI === serverSubjectURI && clientPredicateURI === serverPredicateReplacementURI
			&& clientObjectReplacementObject === serverObjectReplacementObject) {
			// SCENARIO 52a
			let ldd = new LDdelete();
			ldd.setSubject(serverObject.getSubject());
			ldd.setPredicate(serverObject.getPredicate());
			ldd.setObject(serverObject.getObject());
			ldd.setGraph(clientObject.getGraph());
			return ldd;
		}

		if (clientSubjectURI === serverSubjectURI && clientPredicateURI === serverPredicateReplacementURI
			&& clientObjectObject === serverObjectReplacementObject) {
			// SCENARIO 52b
			let ldd = new LDdelete();
			ldd.setSubject(serverObject.getSubject());
			ldd.setPredicate(serverObject.getPredicate());
			ldd.setObject(serverObject.getObject());
			ldd.setGraph(clientObject.getGraph());
			return ldd;
		}

		// SCENARIO 52c and 52d
		return serverObject;
	}

	function applyClientUpdateServerUpdateListTransform(clientObject, serverObject) {
		// This is scenario 40 and scenario 42
		return serverObject;
	}

	// ===================== REPLACE PROCESSING ===================

	function applyClientReplaceTransform(clientObject, serverObject) {

		if (serverObject.constructor === LDdelete) {
			return applyClientReplaceServerDeleteTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDadd) {
			return applyClientReplaceServerAddTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDreplace) {
			return applyClientReplaceServerReplaceTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDupdate) {
			return applyClientReplaceServerUpdateTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDupdateList) {
			return applyClientReplaceServerUpdateListTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDdeleteResource) {
			return applyClientReplaceServerDeleteResourceTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDinsertResource) {
			return applyClientReplaceServerInsertResourceTransform(clientObject, serverObject);
		} else {
			throw new TransformationException("Transforming unrecognised object: " + serverObject.constructor);
		}
	}

	function applyClientReplaceServerDeleteTransform(clientObject, serverObject) {
		// This will cover scenario 50, 50a and 50b

		const clientSubjectURI = clientObject.getSubject().getText();
		const clientPredicateReplacementURI = clientObject.getPredicateReplacement().getText();
		const clientObjectReplacementObject = clientObject.getObjectReplacement().getValue();

		const serverSubjectURI = serverObject.getSubject().getText();
		const serverPredicateURI = serverObject.getPredicate().getText();
		const serverObjectObject = serverObject.getObject().getValue();

		if (clientSubjectURI !== serverSubjectURI) {
			// SCENARIO 50a
			return serverObject;
		}

		if (clientPredicateReplacementURI === serverPredicateURI && clientObjectReplacementObject === serverObjectObject) {
			// SCENARIO 50b
			return serverObject;
		}

		// SCENARIO 50
		return new LDnoop();
	}

	function applyClientReplaceServerDeleteResourceTransform(clientObject, serverObject) {
		return serverObject;
	}

	function applyClientReplaceServerInsertResourceTransform(clientObject, serverObject) {

		const clientSubjectURI = clientObject.getSubject().getText();
		const serverIRI = serverObject.getIRI().getText();

		if (clientSubjectURI === serverIRI) {
			// Operation from server implies resource exists already so replace locally
			let ldrr = new LDreplaceResource();
			ldrr.setIRI(new URI(clientSubjectURI));
			ldrr.setReplacementIRI(new URI(serverIRI));
			ldrr.setData(serverObject.getData());
			ldrr.setGraph(clientObject.getGraph());
			return ldrr;
		}

		return serverObject;
	}

	function applyClientReplaceServerAddTransform(clientObject, serverObject) {
		// This will cover scenarios 48, 48a and 48b

		const clientSubjectURI = clientObject.getSubject().getText();
		const serverSubjectURI = serverObject.getSubject().getText();

		if (clientSubjectURI !== serverSubjectURI) {
			// SCENARIO 48a
			return serverObject;
		}

		// SCENARIO 48 and 48b
		return new LDnoop();
	}

	function applyClientReplaceServerUpdateTransform(clientObject, serverObject) {
		// Scenarios 53, 53a, 53b, 53c and 53d

		const clientSubjectURI = clientObject.getSubject().getText();
		const clientPredicateURI = clientObject.getPredicate().getText();
		const clientObjectObject = clientObject.getObject().getValue();
		const clientPredicateReplacementURI = clientObject.getPredicateReplacement().getText();
		const clientObjectReplacementObject = clientObject.getObjectReplacement().getValue();

		const serverSubjectURI = serverObject.getSubject().getText();
		const serverPredicateURI = serverObject.getPredicate().getText();
		const serverObjectObject = serverObject.getObject().getValue();
		const serverObjectReplacementObject = serverObject.getObjectReplacement().getValue();

		if (clientSubjectURI === serverSubjectURI && clientPredicateURI === serverPredicateURI && clientObjectObject === serverObjectObject) {
			// SCENARIO 53
			return new LDnoop();
		}

		if (clientSubjectURI === serverSubjectURI && clientPredicateReplacementURI === serverPredicateURI
			&& clientObjectReplacementObject === serverObjectReplacementObject) {
			// SCENARIO 53a
			let ldd = new LDdelete();
			ldd.setSubject(serverObject.getSubject());
			ldd.setPredicate(serverObject.getPredicate());
			ldd.setObject(serverObject.getObject());
			ldd.setGraph(clientObject.getGraph());
			return ldd;
		}

		if (clientSubjectURI === serverSubjectURI && clientPredicateReplacementURI === serverPredicateURI
			&& clientObjectReplacementObject === serverObjectObject) {
			// SCENARIO 53b
			return serverObject;
		}

		// SCENARIO 53c and 53d
		return serverObject;
	}

	function applyClientReplaceServerReplaceTransform(clientObject, serverObject) {
		// This will cover scenarios 54, 54a, 54b, 54c and 54d

		const clientSubjectURI = clientObject.getSubject().getText();
		const clientPredicateURI = clientObject.getPredicate().getText();
		const clientPredicateReplacementURI = clientObject.getPredicateReplacement().getText();
		const clientObjectObject = clientObject.getObject().getValue();
		const clientObjectReplacementObject = clientObject.getObjectReplacement().getValue();

		const serverSubjectURI = serverObject.getSubject().getText();
		const serverPredicateURI = serverObject.getPredicate().getText();
		const serverPredicateReplacementURI = serverObject.getPredicateReplacement().getText();
		const serverObjectObject = serverObject.getObject().getValue();
		const serverObjectReplacementObject = serverObject.getObjectReplacement().getValue();

		if (clientSubjectURI !== serverSubjectURI) {
			// So different subjects
			// SCENARIO 54d
			return serverObject;
		}
		if (clientPredicateURI === serverPredicateURI && clientObjectObject === serverObjectObject
			&& clientPredicateReplacementURI === serverPredicateReplacementURI && clientObjectReplacementObject === serverObjectReplacementObject) {
			// So identical operations on both sides
			// SCENARIO 54
			return new LDnoop();
		}
		if (clientPredicateURI === serverPredicateURI && clientObjectObject === serverObjectObject) {
			// Same triple replaced with different things
			// SCENARIO 54a
			let ldr = new LDreplace();
			ldr.setSubject(clientObject.getSubject());
			ldr.setPredicate(clientObject.getPredicateReplacement());
			ldr.setObject(clientObject.getObjectReplacement());
			ldr.setPredicateReplacement(serverObject.getPredicateReplacement());
			ldr.setObjectReplacement(serverObject.getObjectReplacement());
			ldr.setGraph(clientObject.getGraph());
			return ldr;
		}
		if (clientPredicateReplacementURI === serverPredicateReplacementURI && clientObjectReplacementObject === serverObjectReplacementObject) {
			// So different triples replaced with the same thing - delete client triple being replaced
			// SCENARIO 54b
			let ldd = new LDdelete();
			ldd.setSubject(serverObject.getSubject());
			ldd.setPredicate(serverObject.getPredicate());
			ldd.setObject(serverObject.getObject());
			ldd.setGraph(clientObject.getGraph());
			return ldd;
		}

		// SCENARIO 54c
		// Different triples replaced with different things
		return serverObject;
	}

	function applyClientReplaceServerUpdateListTransform(clientObject, serverObject) {
		// This is scenario 56 and scenario 58
		return serverObject;
	}

	// ===================== LIST PROCESSING =======================

	function applyClientUpdateListTransform(clientObject, serverObject) {

		if (serverObject.constructor === LDdelete) {
			return applyClientUpdateListServerDeleteTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDadd) {
			return applyClientUpdateListServerAddTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDreplace) {
			return applyClientUpdateListServerReplaceTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDupdate) {
			return applyClientUpdateListServerUpdateTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDupdateList) {
			return applyClientUpdateListServerUpdateListTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDdeleteResource) {
			return applyClientUpdateListServerDeleteResourceTransform(clientObject, serverObject);
		} else if (serverObject.constructor === LDinsertResource) {
			return applyClientUpdateListServerInsertResourceTransform(clientObject, serverObject);
		} else {
			throw new TransformationException("Transforming unrecognised object: " + serverObject.constructor);
		}
	}

	function applyClientUpdateListServerDeleteTransform(clientObject, serverObject) {
		// This will cover scenarios 11 and 15. Even if the delete triples is the list this still applies
		return serverObject;
	}

	function applyClientUpdateListServerDeleteResourceTransform(clientObject, serverObject) {
		return serverObject;
	}

	function applyClientUpdateListServerInsertResourceTransform(clientObject, serverObject) {
		const clientSubjectURI = clientObject.getSubject().getText();
		const serverIRI = serverObject.getIRI().getText();

		if (clientSubjectURI === serverIRI) {
			// Operation from server implies resource exists already so replace with server version
			let ldrr = new LDreplaceResource();
			ldrr.setIRI(new URI(clientSubjectURI));
			ldrr.setReplacementIRI(new URI(serverIRI));
			ldrr.setData(serverObject.getData());
			ldrr.setGraph(clientObject.getGraph());
			return ldrr;
		}

		return serverObject;
	}

	function applyClientUpdateListServerAddTransform(clientObject, serverObject) {
		// This will cover scenarios 12 and 16
		return serverObject;
	}

	function applyClientUpdateListServerUpdateTransform(clientObject, serverObject) {
		// This is scenario 41 and 43. We work on the assumption that we will not update a list to point somewhere else!
		return serverObject;
	}

	function applyClientUpdateListServerReplaceTransform(clientObject, serverObject) {
		// We work on the assumption that we will not replace a list!
		return serverObject;
	}

	function applyClientUpdateListServerUpdateListTransform(clientObject, serverObject) {
		// This will cover scenarios 17, 18, 19, 20 and 21

		var co = clientObject;
		var so = serverObject;

		// For now we assume start and end indexes (allowing for beginning and
		// end of list) are the same because we only allow an insertion
		var clientSubjectURI = co.getSubject().getText();
		var clientPredicateURI = co.getPredicate().getText();
		var clientStartIndex = parseInt(co.getStartIndex());
		var clientReplacementList = co.getReplacementList();

		var serverSubjectURI = so.getSubject().getText();
		var serverPredicateURI = so.getPredicate().getText();
		var serverStartIndex = parseInt(so.getStartIndex());
		var serverEndIndex = parseInt(so.getEndIndex());
		var serverReplacementList = so.getReplacementList();

		// Not the same subject so this is scenario 17 and scenario 20
		if (clientSubjectURI !== serverSubjectURI || clientPredicateURI !== serverPredicateURI) return serverObject;

		if (clientStartIndex === serverStartIndex) {
			if (clientReplacementList.length === 0) {
				if (serverReplacementList.length === 0) {
					// Scenario 21, where M = N
					return new LDnoop();
				}
			} else if (serverReplacementList.length > 0) {
				// We use array index zero because we only expect one item in update for now
				if (clientReplacementList[0].getText() === serverReplacementList[0].getText()) {
					// Scenario 18 - a no-op on the server
					return new LDnoop();
				}
			}
		}

		// s' is the transform to apply to c on the client
		var sprime = new LDupdateList();
		sprime.setSubject(so.getSubject());
		sprime.setPredicate(so.getPredicate());
		sprime.setReplacementList(serverReplacementList);
		sprime.setGraph(clientObject.getGraph());

		// If no client replacements then this is a client delete scenario
		if (clientReplacementList.length === 0) {
			if (serverReplacementList.length === 0) {
				// Delete on client and server ...
				// Scenario 21
				if (clientStartIndex < serverStartIndex) {
					// Scenario 21, where M < N
					sprime.setStartIndex(serverStartIndex - 1);
					sprime.setEndIndex(serverEndIndex - 1);
				} else {
					// Scenario 21, where M > N
					sprime.setStartIndex(serverStartIndex);
					sprime.setEndIndex(serverEndIndex);
				}
			} else {
				// Delete on client and insert on server
				// Scenario 23
				if (clientStartIndex < serverStartIndex) {
					// Scenario 23, where M <= N
					sprime.setStartIndex(serverStartIndex - 1);
					sprime.setEndIndex(serverEndIndex - 1);
				} else {
					// Scenario 23, where M > N
					sprime.setStartIndex(serverStartIndex);
					sprime.setEndIndex(serverEndIndex);
				}
			}
		} else {
			if (serverReplacementList.length === 0) {
				// Insert on client and delete on server
				// Scenario 22
				if (clientStartIndex <= serverStartIndex
					&& clientStartIndex !== -1) {
					// Scenario 22, where M <= N
					sprime.setStartIndex(serverStartIndex + 1);
					sprime.setEndIndex(serverEndIndex + 1);
				} else {
					// Scenario 22, where M > N
					if (clientStartIndex !== -1) {
						sprime.setStartIndex(serverStartIndex);
						sprime.setEndIndex(serverEndIndex);
					} else {
						// Insert at the end of the list
						sprime.setStartIndex(serverStartIndex);
						sprime.setEndIndex(serverEndIndex);
					}
				}
			} else {
				// Insert on client and server ...
				if (clientStartIndex !== -1
					&& ((clientStartIndex < serverStartIndex) || serverStartIndex === -1)) {
					// Scenario 19, where M < N
					sprime.setStartIndex(serverStartIndex + 1);
					sprime.setEndIndex(serverEndIndex + 1);
				} else {
					// Scenario 19, where M > N
					if (clientStartIndex !== -1) {
						sprime.setStartIndex(serverStartIndex);
						sprime.setEndIndex(serverEndIndex);
					} else {
						// Insert at the end of the list
						sprime.setStartIndex(serverStartIndex);
						sprime.setEndIndex(serverEndIndex);
					}
				}
			}
		}

		return sprime;
	}

}

export default TransformProcessor;